import { render, staticRenderFns } from "./ball-option.vue?vue&type=template&id=b814a41a&scoped=true&"
import script from "./ball-option.vue?vue&type=script&lang=js&"
export * from "./ball-option.vue?vue&type=script&lang=js&"
import style0 from "./ball-option.vue?vue&type=style&index=0&id=b814a41a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b814a41a",
  null
  
)

export default component.exports